import { render, staticRenderFns } from "./DonutChart38.vue?vue&type=template&id=46236a66&scoped=true"
import script from "./DonutChart38.vue?vue&type=script&lang=js"
export * from "./DonutChart38.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46236a66",
  null
  
)

export default component.exports